import React from 'react';

const Donate = (props) => {
  const { attributes, bannerId } = props;
  return <div className={`donate-banner donate-banner-${bannerId}`} {...attributes} />;
};

export default Donate;
